<template>
  <v-layout row wrap>
    <v-flex xs12 sm10 md6 offset-md3 offset-sm1>
      <div v-if="hasfactura"></div>
      <v-card v-else-if="!hasfactura" class="factura" @keyup.ctrl.80 = "impresion">
        <v-card-title class="primary">
          <!--
          <v-flex sm3 xs6 class="hidden-sm-and-down pa-0 ma-0">
            <v-checkbox v-model="escambio" label="cambiar producto" dark>
            </v-checkbox>
          </v-flex>
          !-->
          <h4 class="warning--text existencia"> Existencia: {{producto.existencia}}</h4>
           <v-flex>
            <v-btn fab dark small primary v-on:click.native="dialogbusqueda = true" @click="focusbusqueda()" class="print"  v-bind:disabled="validatefactura">
              <v-icon dark>search</v-icon>

            </v-btn>
        </v-flex>
        </v-card-title>
        <v-flex sm12>
            <v-alert  error value="false" v-if="error">
              {{message_error}}
            </v-alert>
          </v-flex>
        <v-layout class="buscador ma-0 pa-0" fluid wrap >
          <v-flex xs12 sm2 >
          </v-flex>

          <v-flex xs12 sm2 >
            <v-text-field
              singleLine
              label="precio"
              disabled
              v-model="precio"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm3>
            <v-text-field
              singleLine=""
              label="producto"
              disabled
              v-model="producto.producto"
            >
            </v-text-field>
          </v-flex>
          <v-flex  xs4 sm1>
            <v-text-field
              type="number"
              @change="checklista()"
              @keyup.enter="guardarventa"
              singleLine
              label="cantidad"
              min="1"
              v-model="cantidad"
              ref="cantidad"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs4 sm2>
            <div class="select">
               <select v-model="presentacion"  @change="checklista">
                <option v-for="press in presentaciones" v-bind:value="press">
                  {{ press.presentacion }}
                </option>
            </select>
            </div>
          </v-flex>
          <v-flex xs4 sm2>
            <div class="select xs6">
               <select v-model="listado"  @change="checklista">
                <option v-for="lista in producto.listaprecios" v-bind:value="lista">
                  {{ lista.lista.nombre }}
                </option>
            </select>
            </div>
          </v-flex>
          <v-flex hidden-md-and-up class="justify-center" xs12>
            <v-btn fab dark small class="print blue darken-4" @click="guardarventa">
              <v-icon dark>save</v-icon></v-btn>
          </v-flex>
        </v-layout>
      </v-card>
      <v-dialog v-model="dialog" lazy absolute persistent>
      <v-card>
        <v-card-title>
          <div class="headline">Datos Factura</div>
        </v-card-title>
        <v-card-text>
          <v-alert  error value="false" v-if="error">
           {{message_error}}
          </v-alert>
          <v-text-field label="Efectivo" v-model="efectivo" autofocus='true' @keyup.enter="guardardatosfactura">
          </v-text-field>
          <h4 class="primary--text">Cambio: Q.{{cambio}}</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="green--text darken-1" flat="flat" @click.native="dialog = false">Cancelar</v-btn>
          <v-btn class="green--text darken-1" flat="flat" @click.native="guardardatosfactura">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogbusqueda" lazy absolute persistent>
      <v-card>
        <v-card-title>
          <div class="headline">Buscar Producto</div>
           <v-flex sm12>
             <v-text-field label="Nombre" v-model="nombreproducto" @keyup="searchproductos" autofocus ref="searchprodi">
          </v-text-field>
           </v-flex>
        </v-card-title>
        <v-card-text>
          <ul class="listadoproducto">

            <li v-for="product, key in this.productos"
                @click="searchproductodialog(product), dialogbusqueda=false, nombreproducto = ''"
                @keyup.enter="searchproductodialog(product), dialogbusqueda=false, nombreproducto = ''"
                v-bind:tabindex="0">
               {{product.producto}}
            </li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-bind:tabindex="-1" class="green--text darken-1" flat="flat" @click.native="dialogbusqueda = false" @click="resetbusqueda">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="message" lazy absolute persistent>
      <v-card>
        <v-card-title>
          <div class="headline">Escribir Observación</div>
           <v-flex sm12>
             <v-text-field label="comentario" v-model="factura.observaciones"
                           @keyup.enter="cambiarcomentario"
                           multi-line
             >
          </v-text-field>
           </v-flex>
        </v-card-title>
        <v-card-text>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-bind:tabindex="-1" class="green--text darken-1" flat="flat" @click.native="message = false">Cancelar</v-btn>
          <v-btn class="green--text darken-1" flat="flat" @click.native="message = false" @click="cambiarcomentario">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="messagemotivo" lazy absolute persistent >
      <v-card>
        <v-card-title>
          <div class="headline">Motivo por el que no compro</div>
           <v-flex sm12>
             <div class="select">
               <label for="motivo">Motivo:  </label>
               <select v-model="factura.observacionesmotivo"  @change="cambiarcomentariomotivo" id="motivo">
                <option v-for="motivo in motivos" v-bind:value="motivo">
                  {{ motivo }}
                </option>
            </select>
            </div>
           </v-flex>
        </v-card-title>
        <v-card-text>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-bind:tabindex="-1" class="green--text darken-1" flat="flat" @click.native="messagemotivo = false">Cancelar</v-btn>
          <v-btn class="green--text darken-1" flat="flat" @click.native="messagemotivo = false" @click="cambiarcomentariomotivo">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-flex class="firmas">
        <v-flex sm6>Vendedor: {{factura.usuario.username}}</v-flex>
        <v-flex sm6>Cliente</v-flex>
      </v-flex>

    </v-flex>
  </v-layout>
</template>

<script>
  import Fcliente from './Fcliente.vue'
  import NumerosLetras from '../librerias/numerosaletras'
  export default {
    components: {'cliente-factura': Fcliente},
    created: function () {
      this.href.search.focus()
    },
    data () {
      return {
        cantidad: 1,
        iscredito: false,
        prueba: true,
        foco: false,
        nombreproducto: '',
        dialogbusqueda: false,
        escambio: false,
        efectivo: '',
        message: false,
        messagemotivo: false,
        motivos: ['Cerrado', 'Ausente', 'Compra Barato', 'Tiene Producto'],
        headers: [
          { text: 'Cantidad' },
          { text: ' Presentación' },
          { text: 'Descripción' },
          { text: 'Precio' },
          { text: 'Subtotal' }
        ]
      }
    },
    methods: {
      searchproducto () {
        this.$store.dispatch('buscarproducto', {producto: this.producto.barra})
        this.$refs.cantidad.focus()
      },
      searchproductodialog (event) {
        if (event.barra) {
          this.$store.dispatch('buscarproducto', {producto: event.barra})
        } else {
          this.$store.dispatch('buscarproducto', {producto: event.codigo})
        }
        this.$refs.cantidad.focus()
      },
      searchproductos () {
        this.$store.dispatch('buscarproductos', {producto: this.nombreproducto})
      },
      checklista () {
        if (this.listado.lista.nombre.toLowerCase() !== 'l4' && this.listado.lista.nombre.toLowerCase() !== 'l5' && this.producto.listaprecios.length <= 2) {
          let listadoordenado = this.producto.listaprecios.sort((dato1, dato2) => {
            return dato1.minimo - dato2.minimo
          })
          let listas = []
          let lista = []
          listadoordenado.map((dato) => {
            if (dato.lista.nombre.toLowerCase() !== 'l4' &&
              dato.lista.nombre.toLowerCase() !== 'l5' && dato.minimo <=
              this.cantidad * (this.presentacion.unidades)) {
              listas.push(dato)
            }
          })
          if (listas.length > 0) {
            lista = listas.reverse()
            this.$store.commit('updateselect', lista[0])
          } else {
            listas = listadoordenado.map(dato => {
              if (dato.lista.nombre.toLowerCase() !== 'l4' && dato.lista.nombre.toLowerCase() !== 'l5') {
                lista.push(dato)
              }
            })
            this.$store.commit('updateselect', lista[0])
          }
        }
      },
      resetbusqueda () {
        this.nombreproducto = ''
        this.$store.commit('actualizarproductos', [])
      },
      redondear (cantidad) {
        let exponente = 100
        let prueba = cantidad.toFixed(2)
        let reciduo = parseInt((prueba * exponente).toFixed() % 5)
        if (reciduo !== 0) {
          return (parseInt((cantidad.toFixed(2) * exponente).toFixed()) + 5 - reciduo) / exponente
        } else {
          return (cantidad.toFixed(2) * exponente) / exponente
        }
      },
      focusbusqueda () {
        let vm = this
        setTimeout(function () {
          vm.$refs.searchprodi.focus()
        }, 100)
      }
    },
    computed: {
      productos: function () {
        return this.$store.getters.productos
      },
      haslineas: function () {
        if (this.lineas.length > 0) {
          return true
        } else {
          return false
        }
      },
      hasfactura: function () {
        return false
      },
      factura: function () {
        return this.$store.getters.factura
      },
      lineas: function () {
        return this.$store.getters.lineasfactura
      },
      total: function () {
        let temptotal = 0
        this.lineas.map(dato => {
          temptotal += dato.cantidad * dato.precio
        })
        return (temptotal).toFixed(2) || 0
      },
      cliente: function () {
        return this.$store.getters.cliente
      },
      producto: function () {
        return this.$store.getters.producto
      },
      fecha: function () {
        let fecha = new Date(this.$store.getters.factura.fecha)
        return fecha.toLocaleDateString('es-gt')
      },
      hora: function () {
        let fecha = new Date(this.$store.getters.factura.fecha)
        return fecha.toLocaleTimeString('es-gt')
      },
      listado: {
        get: function () {
          return this.$store.getters.listado || ''
        },
        set: function (dato) {
          this.$store.commit('updateselect', dato)
        }
      },
      dialog: {
        get: function () {
          return this.$store.getters.dialogo
        },
        set: function (dato) {
          this.$store.commit('actualizardialog', dato)
        }
      },
      precio: {
        get: function () {
          if (this.presentacion.presentacion === 'unidad') {
            return this.redondear(this.producto.precio_costo * (1 + this.listado.porcentaje / 100)) * this.presentacion.unidades
          }
          if (this.presentacion.presentacion !== 'unidad' && (this.listado.lista.nombre !== 'l6' || this.listado.lista.nombre !== 'l7')) {
            return this.redondear(this.producto.precio_costo * (1 + this.listado.porcentaje / 100) * this.presentacion.unidades)
          }
          return this.redondear(this.producto.precio_costo * (1 + this.listado.porcentaje / 100) * this.presentacion.unidades)
        }
      },
      presentaciones: function () {
        return this.$store.getters.presentaciones
      },
      presentacion: {
        get: function () {
          return this.$store.getters.presentacion
        },
        set: function (dato) { this.$store.commit('actualizarpresentacion', dato) }
      },
      error: function () {
        return this.$store.getters.error_numero
      },
      cambio: function () {
        return (this.total - this.efectivo).toFixed(2)
      },
      message_error: function () {
        return this.$store.getters.message_error
      },
      numerosaletras: function () {
        return NumerosLetras.NumeroALetras(this.total, {
          plural: 'QUETZALES',
          singular: 'QUETZAL',
          centPlural: 'CENTAVOS',
          centSingular: 'CENTAVOS'
        })
      },
      validatefactura: function () {
        if (this.lineas.length === 13) {
          return true
        }
        return false
      }
    }
  }
</script>
<style>
   @media only screen and (min-device-width: 480px){
     .existencia {
       position: fixed;
       top: 1em;
     }
     .existencia{
       position: fixed;
       left: 10em;
       top: 6.1em;
     }
     .listadoproducto li {
       padding: 8px;
     }
   }
</style>



// WEBPACK FOOTER //
// Buscador.vue?63a3a9b6